<template>
  <div class="clear-both"></div>
  <div class="container">
    <div class="row">
      <div class="flex justify-between">
        <div class="w-1/2 p-4">
          <h2>ApiDomains</h2>
          <div v-for="(link, key) in apiDomains" :key="'form-' + key">
            <div>
              <label :for="'input-' + key" class="form-label mt-5">Link {{ key + 1}}</label>
              <input :id="'input-' + key" type="text" v-model="apiDomains[key]" class="form-input"/>
            </div>
          </div>
          <h2 class="mt-5">cdnDomains</h2>
          <div v-for="(link, key) in cdnDomains" :key="'form-' + key">
            <div>
              <label :for="'input-' + key" class="form-label mt-5">Link {{ key + 1}}</label>
              <input :id="'input-' + key" type="text" v-model="cdnDomains[key]" class="form-input"/>
            </div>
          </div>
          <h2 class="mt-5">Tracking Domains</h2>
          <div v-for="(link, key) in trackingDomains" :key="'form-' + key">
            <div>
              <label :for="'input-' + key" class="form-label mt-5">Domain {{ key + 1}}</label>
              <input :id="'input-' + key" type="text" v-model="trackingDomains[key]" class="form-input"/>
            </div>
          </div>
          <h2 class="form-label mt-5">UpdateLink</h2>
          <input type="text" v-model="updateLink" class="form-input"/>
          <h2 class="form-label mt-5">promoWeblink</h2>
          <input type="text" v-model="promoWeblink" class="form-input"/>
          <h2 class="form-label mt-5">TooManyDevicesLink</h2>
          <input type="text" v-model="tooManyDevicesLink" class="form-input"/>
          <h2 class="form-label mt-5">iosLink</h2>
          <input type="text" v-model="iosLink" class="form-input"/>
          <h2 class="form-label mt-5">macOSLink</h2>
          <input type="text" v-model="macOSLink" class="form-input"/>
          <h2 class="form-label mt-5">androidLink</h2>
          <input type="text" v-model="androidLink" class="form-input"/>
          <h2 class="form-label mt-5">windowsLink</h2>
          <input type="text" v-model="windowsLink" class="form-input"/>
          <h2 class="form-label mt-5">weblink</h2>
          <div v-for="(link, key) in weblinks" :key="'form-' + key">
            <div>
              <input :id="'input-' + key" type="text" v-model="weblinks[key].link" class="form-input"/>
            </div>
          </div>
          <h2 class="form-label mt-5">inviteURL</h2>
          <input type="text" v-model="inviteURL" class="form-input"/>
          <loading-button :loading="loading" @click="submitLink" class="mt-5 btn-indigo ml-auto">
            Save Api Domains
          </loading-button>
        </div>
        <div class="w-1/2 p-4">
          <pre>{{ jsonString }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {Head} from "@inertiajs/vue3";
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
  },
  props: {
    config: Object,
    guid: String,
    appName: String,
  },
  layout: Layout,
  data() {
    return {
      loading: false,
      guid: this.guid,
      apiDomains: this.config.apiDomains,
      cdnDomains: this.config.cdnDomains,
      trackingDomains: this.config.trackingDomains,
      updateLink: this.config.updateLink,
      tooManyDevicesLink:this.config.tooManyDevicesLink,
      iosLink:this.config.iosLink,
      macOSLink:this.config.macOSLink,
      androidLink:this.config.androidLink,
      windowsLink:this.config.windowsLink,
      weblinks:this.config.weblinks,
      promoWeblink:this.config.promoWeblink,
      inviteURL:this.config.inviteURL,
    };
  },
  methods: {
    submitLink() {
      this.loading = true;
      axios.post('/api/config/update-batch', {
        data: {
          apiDomains:this.apiDomains,
          cdnDomains:this.cdnDomains,
          trackingDomains:this.trackingDomains,
          updateLink:this.updateLink,
          tooManyDevicesLink:this.tooManyDevicesLink,
          iosLink:this.iosLink,
          androidLink:this.androidLink,
          windowsLink:this.windowsLink,
          weblinks:this.weblinks,
          promoWeblink:this.promoWeblink,
          inviteURL:this.inviteURL
        },
        guid: this.guid,
        appName: this.appName
      })
          .then(response => {
            this.loading = false;
            alert(`Update is queued`);
          })
          .catch(error => {
            console.error(`Error saving ${key}:`, error);
            alert(`Failed to save ${key}.`);
          });
    },
    serialize(obj) {
      const result = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] !== 'function') {
            result[key] = obj[key];
          }
        }
      }
      return result;
    }
  },
  mounted() {
    console.log(this.config);
  },
  computed: {
    jsonString() {
      const dataForJson = this.serialize(this.config);
      return JSON.stringify(dataForJson, null, 2);
    }
  }
}
</script>
